module.exports = __webpack_public_path__ + "img/8_52.30a043b1.png";